import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import CustomInputField from '../../Common_Components/CustomInputField';
import CustomTextArea from '../../Common_Components/CustomTextArea';
import { useNavigate, useParams } from 'react-router-dom';
import ResetButton from '../../Common_Components/ResetButton';
import SaveButton from '../../Common_Components/SaveButton';
import axios from 'axios'; // Axios for API calls
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import { Toast } from '../../Common_Components/Toast';
import axiosInstance from '../../axios/axios';

const AddProduct = () => {
    const navigate = useNavigate();
    const { id } = useParams()
    // State for form data
    const [formData, setFormData] = useState({
        productName: '',
        version: '',
        description: '',
    });
    const statusList = [{ id: 1, label: "Active" }, { id: 0, label: "Inactive" }]
    const [status, setStatus] = useState(null)
    // State for handling loading or feedback
    const [isSaving, setIsSaving] = useState(false);

    // Handler for the back arrow click
    const handleBackClick = () => navigate(-1);

    // Handler for input changes
    const handleChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
    };
    useEffect(() => {
        const getProductByID = async () => {
            const response = await axiosInstance.get(`/product/view/${id}`)
            const { success, product } = response.data
            if (success === true) {
                const req = {
                    productName: product?.PD_Name,
                    version: product?.PD_Version,
                    description: product?.PD_Description,
                }
                setFormData(req)
                setStatus(statusList.find((s) => s.id === product.PD_StatusID));
            }
        }
        if (id) {
            getProductByID()
        }

    }, [id])
    // Handler for form reset
    const handleReset = () => {
        setStatus(null)
        setFormData({
            productName: '',
            version: '',
            description: '',
        });
    };
    const handleValidation = () => {
        // Validation checks for each field
        if (!formData.productName) {
            Toast.warning('Product is required');
            return false;
        }

        if (!formData.version) {
            Toast.warning('Product Version is required');
            return false;
        }

        if (!formData.description) {
            Toast.warning('Description is required');
            return false;
        }
        if (!status) {
            Toast.warning('Status is required');
            return false;
        }

        return true; // Return true if no errors
    };
    // Handler for form save
    const handleSave = async (e) => {
        e.preventDefault();
        // Validate before submitting
        if (!handleValidation()) return;
        setIsSaving(true);
        const request = {
            PD_Name: formData.productName,
            PD_Version: formData.version,
            PD_StatusID: status?.id,
            PD_Description: formData.description,
        }
        if (id) {
            try {
                const response = await axiosInstance.post(`/product/edit/${id}`, request); // Replace with your API endpoint
                const { success, message } = response.data
                if (success === true) {
                    Toast.success(message);
                    navigate('/product-management');
                } else {
                    Toast.warning(message)
                }
            } catch (error) {
                console.error('Error saving product:', error);
                Toast.error('Failed to save the product. Please try again.');
            } finally {
                setIsSaving(false);
            }
        } else {
            try {
                const response = await axiosInstance.post('/product/add', request); // Replace with your API endpoint
                const { success, message } = response.data
                if (success === true) {
                    Toast.success(message);
                    navigate('/product-management');
                } else {
                    Toast.warning(message)
                }
            } catch (error) {
                console.error('Error saving product:', error);
                Toast.error('Failed to save the product. Please try again.');
            } finally {
                setIsSaving(false);
            }
        }

    };

    return (
        <Box display="flex" padding={2} flexDirection="column" minHeight="100vh">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap">
                <Box display="flex" alignItems="center" mb={{ xs: 2, md: 0 }}>
                    <ArrowBack
                        onClick={handleBackClick}
                        style={{
                            cursor: 'pointer',
                            marginRight: '8px',
                            height: '34px',
                            width: '38px',
                            color: '#545454',
                        }}
                    />
                    <Typography
                        sx={{
                            fontFamily: 'Times New Roman',
                            fontWeight: '700',
                            fontSize: { xs: '24px', md: '32px' },
                            color: '#545454',
                        }}
                    >
                        Add Product
                    </Typography>
                </Box>
                <Box>
                    <ResetButton label="Reset" onClick={handleReset} />
                    <SaveButton label="Save" onClick={handleSave} disabled={isSaving} />
                </Box>
            </Box>

            <Paper elevation={3} sx={{ padding: { xs: 2, md: 4 } }}>
                <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" gap={2}>
                    <Box flexBasis={{ xs: '100%', sm: '48%', md: '30%' }}>
                        <CustomInputField
                            label="Product Name"
                            value={formData.productName}
                            onChange={(e) => handleChange('productName', e.target.value)}
                            fullWidth
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', sm: '48%', md: '30%' }}>
                        <CustomInputField
                            label="Version"
                            value={formData.version}
                            onChange={(e) => handleChange('version', e.target.value)}
                            fullWidth
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', sm: '48%', md: '30%' }}>
                        <CustomSelectBox
                            label="Status"
                            options={statusList}
                            Value={status}
                            setValue={setStatus}
                            fullWidth
                        />
                    </Box>
                    <Box flexBasis="100%">
                        <CustomTextArea
                            label="Description"
                            value={formData.description}
                            onChange={(e) => handleChange('description', e.target.value)}
                            rows={5}
                            fullWidth
                        />
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default AddProduct;
